export const Header = ({surauData}) =>{
    return (
        <div className="headerContainer">
            <h1 className='arabFont'>افتر دان موريه</h1>
            <h1>Sumbangan Ramadhan {surauData.name}</h1>
            <h2>{surauData.address}</h2>
        </div>
    )
}